import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
// import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Account from "../views/Accounts.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import Invitation from "../views/Invitation.vue";
import Templates from "../views/Templates.vue";
import Guests from "../views/Guests.vue";
import GuestCategory from "../views/GuestCategory.vue";
import EventSettings from "../views/EventSettings.vue";
import Comments from "../views/Comments.vue";
import Reception from "../views/Reception.vue";


const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/signin",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/tables",
    name: "Message Template",
    component: Tables,
  },
  {
    path: "/billing",
    name: "Guest Categories",
    component: Billing,
  },
  {
    path: "/virtual-reality",
    name: "Guests List",
    component: Tables,
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/account",
    name: "Account",
    component: Account,
  },
  {
    path: "/account-admin",
    name: "Account",
    component: Account,
  },
  {
    path: "/account-reception",
    name: "Account",
    component: Reception,
  },
  {
    path: "/invitation/:id",
    name: "Invitation",
    component: Invitation,
  },
  {
    path: "/watemplate",
    name: "Message Template",
    component: Templates,
  },
  {
    path: "/guestcategory",
    name: "Guest Category",
    component: GuestCategory,
  },
  {
    path: "/guests",
    name: "Guests List",
    component: Guests,
  },
  {
    path: "/comments",
    name: "Comment Approval",
    component: Comments,
  },
  {
    path: "/settings",
    name: "Settings",
    component: EventSettings,
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/super",
    name: "Superadmin",
    redirect: "/signup",
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
